import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--send" icon='send'>{ children ? children : 'Send' }</Button>
}